"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveImageUrl = resolveImageUrl;

/**
 * Module dependencies.
 */

/**
 * Export `resolveImageUrl`.
 */
function resolveImageUrl(media) {
  if (!media || (media === null || media === void 0 ? void 0 : media.status) === 'processing') {
    return null;
  } // $FlowFixMe


  var previewUrl = media.previewUrl,
      type = media.type,
      url = media.url;

  switch (type) {
    case 'image':
      return url;

    case 'video':
      return previewUrl;

    default:
      throw new Error('Invalid avatar media type');
  }
}